<template>
  <div id="vp-root" class="vp-root" :class="{ 'vp-root--portal': isPortal, 'vp-root--auth': isAuth }">
    <main class="vp-main">
      <router-view />
    </main>
  </div>
</template>

<script>
import { setApiServer } from '@/config/api'
import { FIXED_API_SERVER } from '@/config/demoProject'

export default {
  name: 'App',
  computed: {
    isPortal () {
      return this.$route && this.$route.name === 'portal'
    },
    isAuth () {
      return this.$route && (this.$route.name === 'login' || this.$route.name === 'home')
    }
  },
  created () {
    setApiServer(FIXED_API_SERVER)
  }
}
</script>
